import {
  backgroundColorCss,
  borderCss,
  mobileBackgroundColorCss,
  mobileBorderCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import { css, styled } from 'styled-components'
import { FormLayoutEnum } from '../enums'
import { FormInterface } from '../form.schema'

export interface CommonFormUiStylesInterface
  extends Pick<
    FormInterface,
    | 'layout'
    | 'rowGap'
    | 'mobileRowGap'
    | 'columnGap'
    | 'border'
    | 'mobileBorder'
    | 'padding'
    | 'mobilePadding'
    | 'backgroundColor'
    | 'mobileBackgroundColor'
  > {}
export const CommonFormUi = styled.form<CommonFormUiStylesInterface>`

  display: grid;
  position: relative;
  ${p => p.rowGap && `row-gap: ${p.rowGap}px;`}
  ${p => p.columnGap && `column-gap: ${p.columnGap}px;`}

  width: 100%;

  ${p =>
    p.layout === FormLayoutEnum.OneColumn
      ? 'grid-template-columns: 1fr;'
      : 'grid-template-columns: 1fr 1fr;'}

  ${borderCss}
  ${paddingsCss}
  ${backgroundColorCss}
  
  ${p => p.theme.phone} {
    grid-template-columns: 1fr;
    ${p => p.mobileRowGap && `row-gap: ${p.mobileRowGap}px;`}

    ${mobileBorderCss}
    ${mobilePaddingsCss}
    ${mobileBackgroundColorCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      grid-template-columns: 1fr;
      ${p.mobileRowGap && `row-gap: ${p.mobileRowGap}px;`}

      ${mobileBorderCss}
      ${mobilePaddingsCss}
      ${mobileBackgroundColorCss}
  `}
`
